import React, { useEffect, useState } from 'react'
import { 
  Modal, 
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input
} from 'reactstrap'
import _ from 'lodash'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'
 
const defaultValue = {
  name: '',
}

const FormContent = ({
  mode,
  open,
  onLoadSecModule,
  onClose,
  selectedFormData,
  onClickSubmit
}) => {

  const [ secModulesData, onChangeSecModulesData ] = useState( defaultValue )

  useEffect(() => {
    if ( open && mode === 'Edit' ){
      onChangeSecModulesData( selectedFormData )
    } 
    if ( !open ){
      onChangeSecModulesData( defaultValue )
    }
  }, [open])

  useEffect(() => {
    mode === 'Edit' && onChangeSecModulesData( selectedFormData )
  }, [ selectedFormData ])

  const onChangeSecModulesField = ( key, val ) => {
    let tmp = _.cloneDeep( secModulesData )
    tmp[ key ] = val
    return onChangeSecModulesData( tmp )
  }

  return (
    <Modal
      isOpen={ open }
      size={ 'xl' }>
      <ModalHeader toggle={() => onClose()}>{ `${ mode } sec modules` }</ModalHeader>
      <ModalBody>
        <Form onSubmit={ e => e.preventDefault()}>
          <FormGroup>
            <Label>
              Name
              <span className="text-danger"> *</span>
            </Label>
            <Input
              type={ 'text' }
              value={ secModulesData.name }
              onChange={ e => {
                onChangeSecModulesField( 'name', e.target.value )
              }} />
          </FormGroup>
        </Form>
        { onLoadSecModule && <LoadingOverlay/> }
      </ModalBody>
      <ModalFooter>
        <Button 
          className="mr-2"
          color={ _.values( secModulesData ).some( item => !item ) ? 'secondary' : 'primary' }
          disabled={ _.values( secModulesData ).some( item => !item )}
          onClick={() => {
            onClickSubmit({
              ... secModulesData,
            })
          }}>
          Submit
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default FormContent